const participants = {
  computed: {
    STATUSES() {
      return {
        CREATED: 'created',
        PENDING: 'pending',
        SIGNED: 'signed',
        VIEWED: 'viewed',
        FILLED: 'filled',
        APPROVED: 'approved',
        REJECTED: 'rejected',
        CANCELLED: 'cancelled'
      }
    },
    participantActionsMap() {
      return {
        VIEW: 'view',
        SIGN: 'sign',
        FILL: 'fill',
        APPROVE: 'approve'
      }
    },
    participantsRoleActionMap() {
      return {
        DOCUMENT_SIGNER: this.participantActionsMap.SIGN,
        DOCUMENT_APPROVER: this.participantActionsMap.APPROVE,
        DOCUMENT_VIEWER: this.participantActionsMap.VIEW,
        DOCUMENT_FILLER: this.participantActionsMap.FILL
      }
    },
    participantsRoleLabelMap() {
      return {
        DOCUMENT_SIGNER: this.$t('Signature'),
        DOCUMENT_APPROVER: this.$t('Approve'),
        DOCUMENT_VIEWER: this.$t('View'),
        DOCUMENT_FILLER: this.$t('Filling')
      }
    },
    mapParticipantActionToText() {
      return {
        [this.participantActionsMap.APPROVE]: this.$t('To approve'),
        [this.participantActionsMap.VIEW]: this.$t('To view'),
        [this.participantActionsMap.SIGN]: this.$t('To sign'),
        [this.participantActionsMap.FILL]: this.$t('To fill')
      }
    },
    participantActions() {
      const actions = [
        {
          text: this.$t('To view'),
          value: this.participantActionsMap.VIEW
        },
        {
          text: this.$t('Sign'),
          value: this.participantActionsMap.SIGN
        },
        {
          text: this.$t('To fill'),
          value: this.participantActionsMap.FILL
        }
      ]
      if (this.$hasProVersion) {
        actions.push({
          text: this.$t('To approve'),
          value: this.participantActionsMap.APPROVE
        })
      }
      return actions
    },
    proParticipantActions() {
      return this._.filter(
        this.participantActions,
        action => action.value !== this.participantActionsMap.FILL
      )
    },
    bundleActions() {
      return this._.filter(
        this.participantActions,
        action =>
          action.value !== this.participantActionsMap.FILL &&
          action.value !== this.participantActionsMap.APPROVE
      )
    },
    ownerActions() {
      return [
        {
          text: this.$t('Sign'),
          value: true
        },
        {
          text: this.$t('Do not sign'),
          value: false
        }
      ]
    },
    participantModes() {
      return {
        NEW: 'new',
        SAVED: 'saved',
        PUBLIC: 'public'
      }
    }
  },
  methods: {
    setParticipantIdentifier(value) {
      return isFinite(value) && value.length >= 8 && value.length <= 10 ? 'edrpou' : 'email'
    },
    canEditParticipant(participant) {
      const isNewUser = !participant.status
      return isNewUser || participant.status === this.STATUSES.CREATED
    },
    canDeleteParticipant(participant) {
      const isNewUser = !participant.status
      return (
        isNewUser ||
        [this.STATUSES.CREATED, this.STATUSES.PENDING, this.STATUSES.VIEWED].includes(
          participant.status
        )
      )
    },
    canEditParticipantsRouteStrictness(participants) {
      const firstSigner = this._.findIndex(
        participants,
        participant => participant.action === this.participantActionsMap.SIGN
      )
      if (firstSigner !== -1) {
        const slicedParticipants = participants.slice(0, firstSigner)
        return this._.some(slicedParticipants, (item, idx) => {
          const nextParticipant = participants[idx + 1]
          return (
            item.action === this.participantActionsMap.APPROVE &&
            nextParticipant?.action === this.participantActionsMap.APPROVE
          )
        })
      } else {
        return this._.some(participants, (item, idx) => {
          const nextParticipant = participants[idx + 1]
          return (
            item.action === this.participantActionsMap.APPROVE &&
            nextParticipant?.action === this.participantActionsMap.APPROVE
          )
        })
      }
    }
  }
}

export default participants
